import { sort_center_api } from '@shared/api';

function cleanScannerCode(value: string): string {
  // eslint-disable-next-line no-control-regex
  return value.replace(/[\x00-\x1F\x7F]/g, '');
}

export async function getParcelPostalLabel(trackNumber: string): Promise<Blob> {
  const cleanTrackNumber = cleanScannerCode(trackNumber);
  const url = 'v1/parcels/postal/:x/label'.replace(':x', cleanTrackNumber);

  const response = await sort_center_api.get(url, {
    responseType: 'blob',
  });

  return new Blob([response.data], { type: 'application/pdf' });
}

export async function getBagPostalLabel(bagNumber: string): Promise<Blob> {
  const cleanBagNumber = cleanScannerCode(bagNumber);
  const url = 'v1/bags/postal/:x/label'.replace(':x', cleanBagNumber);

  const response = await sort_center_api.get(url, {
    responseType: 'blob',
  });

  return new Blob([response.data], { type: 'application/pdf' });
}
